var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthorityFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0.5);opacity:0;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(78 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81 231)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M111,355.71h0a.527.527,0,0,0-.526.527V361.2h1.057v-4.967A.527.527,0,0,0,111,355.71Z",
    transform: "translate(-106.59 -343.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M241,335.41h0a.527.527,0,0,0-.526.527v5.681h1.057v-5.681A.527.527,0,0,0,241,335.41Z",
    transform: "translate(-232.016 -323.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M371.995,355.71h0a.527.527,0,0,0-.526.527V361.2h1.057v-4.967A.527.527,0,0,0,371.995,355.71Z",
    transform: "translate(-358.405 -343.205)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 0.528,
    cy: 0.527,
    rx: 0.528,
    ry: 0.527,
    transform: "translate(8.472 6.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.022,9.288H18V8.028a.528.528,0,0,0-.342-.494L9.526,4.481V3.164h2.891a.527.527,0,0,0,.526-.527V.879a.527.527,0,0,0-.526-.527H9.5A.526.526,0,0,0,8.474.527V4.481L.353,7.53l-.012,0A.527.527,0,0,0,0,8.028v1.26H5.978a.588.588,0,0,1,0,1.176H.739v7.008A.527.527,0,0,0,1.265,18H2.831V13.033A1.582,1.582,0,0,1,4.41,11.451h0a1.582,1.582,0,0,1,1.579,1.582V18H7.4V12.319A1.582,1.582,0,0,1,8.98,10.737h0a1.582,1.582,0,0,1,1.579,1.582V18h1.443V13.033a1.582,1.582,0,0,1,1.579-1.582h0a1.582,1.582,0,0,1,1.579,1.582V18h1.566a.527.527,0,0,0,.526-.527V10.464H12.022a.588.588,0,0,1,0-1.176ZM9,8.386A1.582,1.582,0,1,1,10.581,6.8,1.583,1.583,0,0,1,9,8.386Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorityFill);
export default __webpack_public_path__ + "static/media/authorityFill.584515589e1beebe62686812ddd201b3.svg";
export { ForwardRef as ReactComponent };